<li class="nav-item pr-4 pl-3">
    <a class="nav-link" (click)="logout()">
        <i class="fa fa-sign-out"></i> {{'Log Out' | translatelayout: locale}}
    </a>
</li>
